export default function () {
    const $config = useRuntimeConfig().public;
    const $route = useRoute();
    const schemaKeywords = useSchemaKeywords();
    const { sanitizeHtml } = useUtilitySanitize();

    function build(course) {
        if (!course) return undefined;

        function buildCourseSchema() {
            // Helper function to get instrument type
            function getInstrumentText(course) {
                const instrumentType = course?.course_lessons?.[0]?.lesson_instrument || 'Guitar';
                return instrumentType === 'Ukulele' ? 'Ukulele' :
                    instrumentType === 'Electric' ? 'Electric Guitar' :
                        instrumentType === 'Acoustic' ? 'Acoustic Guitar' : 'Guitar';
            }

            // Helper function to get difficulty level
            function getDifficultyInfo(course) {
                return course?.course_lessons?.[0]?.lesson_difficulty || 'All Levels';
            }

            const instrumentText = getInstrumentText(course);
            const difficultyText = getDifficultyInfo(course);
            const lessonCount = course?.course_lessons?.length || 0;
            const sanitizedExcerpt = sanitizeHtml(course.course_excerpt);

            const baseSchema = {
                '@type': 'Course',
                'url': $config.base + $route.path,
                'name': course.course_title,
                'description': sanitizedExcerpt,
                'provider': {
                    '@type': 'Organization',
                    'name': 'Andy Guitar',
                    'sameAs': $config.base,
                    'member': {
                        '@type': 'Person',
                        'name': 'Andy Crowley',
                        'description': 'Professional guitar instructor with over 15 years of teaching experience'
                    }
                },
                'teaches': {
                    '@type': 'DefinedTerm',
                    'name': `${instrumentText} Playing`,
                },
                'hasCourseInstance': {
                    '@type': 'CourseInstance',
                    'courseMode': 'Online',
                    'courseWorkload': `PT${(lessonCount || 1) * 15}M`,
                    'instructor': {
                        '@type': 'Person',
                        'name': 'Andy Crowley',
                        'jobTitle': 'Guitar Instructor'
                    },
                    'courseSchedule': {
                        '@type': 'Schedule',
                        'repeatCount': lessonCount || 1,
                        'repeatFrequency': 'Daily'
                    }
                },
                'offers': course.course_archetype === 'free' ? {
                    '@type': 'Offer',
                    'availability': 'https://schema.org/InStock',
                    'price': '0',
                    'priceCurrency': 'GBP',
                    'category': 'Guitar Instruction'
                } : {
                    '@type': 'Offer',
                    'availability': 'https://schema.org/InStock',
                    'category': 'Guitar Instruction',
                    'priceSpecification': [
                        {
                            '@type': 'PriceSpecification',
                            'price': '10.99',
                            'priceCurrency': 'GBP',
                            'validFrom': new Date().toISOString().split('T')[0],
                            'validThrough': new Date(new Date().setMonth(new Date().getMonth() + 1)).toISOString().split('T')[0]
                        },
                    ]
                },
                'educationalLevel': difficultyText.toLowerCase(),
                'learningResourceType': 'Video Course',
                'image': course.course_image_url,
                'inLanguage': 'en-GB',
                'timeRequired': `PT${(lessonCount || 1) * 15}M`,
                'keywords': schemaKeywords.generateKeywords.course(course),
                'educationalAlignment': {
                    '@type': 'AlignmentObject',
                    'alignmentType': 'teaches',
                    'educationalFramework': `${instrumentText} Performance Skills`,
                    'targetName': `${difficultyText} ${instrumentText} Playing`,
                    'targetUrl': `${$config.base}/courses`
                }
            };

            return baseSchema;
        }

        const schemaData = [
            buildCourseSchema(),
            useSchemaBreadcrumb().buildCourse(course)
        ];

        return useSchema().build(schemaData);
    }

    return { build };
}
